import capitalize from 'lodash/capitalize'

export const formattedPercentage = (val?: number, maximumFractionDigits = 1) => ((val ?? 0) * 100).toLocaleString('no-NO', { maximumFractionDigits }) + ' %'

export const capitalizeWords = (value: string): string => value.split(' ').map(capitalize).join(' ')

const conjunctionFormatter = new Intl.ListFormat('nb-no', { type: 'conjunction' })

/**
 * Formats a list to be joined with a conjunction, eg "Rom 1, Rom 2 og Rom 3"
 */
export const joinWithConjunction = (items: string[]) => conjunctionFormatter.format(items)
